<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('customer_preorder_overview.page_title') }}</slot>
            <slot slot="description">
                <p>{{ $t('preorder_overview.description') }}</p>
            </slot>
        </page-header>

        <v-overview-list
                data-table="PreOrders"
                data-filter="PreOrdersFilters"
                data-pagination="PreOrdersPagination"
                btnViewPath="SalesmanPreOrdersEdit"
                filter-theme="white"
                :filters="PreOrders.filters"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :btnExportPreOrder="true"
                :btnResendPreOrder="true"
                :page-size="12"
                prefix="lop">
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            PreOrders() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.customer'), value: 'Customers', single: 'customer', width:150 },
                        { name: this.$t('preorder_overview.filters.states'), value: 'States', single: 'state', width:150 },
                        { name: this.$t('preorder_overview.filters.salesman'), value: 'Sales', single: 'sales', width:220 }
                    ],
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        // { value: 'ProcessDate', name: 'Process Datum', type: 'Date' },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key') },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },
                        { value: 'LastUpdate', name: 'Laatste update', type: 'Date' },
                        { value: 'SalesMan', name: this.$t('preorder_overview.columns.salesman')},
                        { value: 'State', name: this.$t('preorder_overview.columns.state') },
                        { value: 'SystemStateDisplay', name: this.$t('preorder_overview.columns.system_state') }
                    ]
                };
            },
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/preOrders/CustomerPreOrders.vue